class BlobsSection {
    constructor(section, listItems, descItems) {
        this.section = section;
        this.listItems = listItems;
        this.descItems = descItems;
        this.handleListItemClick = this.handleListItemClick.bind(this);
        this.init();
    }
    init() {
        this.addEventListeners();
    }
    addEventListeners() {
        this.listItems.forEach((button) => {
            button.addEventListener("click", this.handleListItemClick);
        });
    }
    removeEventListeners() {
        console.log(this, "removed");
        this.listItems.forEach((button) => {
            button.removeEventListener("click", this.handleListItemClick);
        });
    }
    handleListItemClick(event) {
        const target = event.currentTarget;
        this.resetActiveListItems();
        target.classList.add("active");
        this.showActiveDescription(target.value);
    }
    showActiveDescription(activeElement) {
        const active = this.section.querySelector("#" + activeElement);
        this.resetDescItems();
        active.classList.remove("d-none");
    }
    resetActiveListItems() {
        this.listItems.forEach((item) => {
            item.classList.remove("active");
        });
    }
    resetDescItems() {
        this.descItems.forEach((item) => {
            item.classList.add("d-none");
        });
    }
}
export const initBlobsSection = () => {
    const sections = [...document.querySelectorAll(".blobs_list-layout")];
    if (!sections.length)
        return;
    sections.map((section) => {
        // prettier-ignore
        const listItems = [...section.querySelectorAll(".blobs_list-item")];
        // prettier-ignore
        const descItems = [...section.querySelectorAll(".blobs_desc-item")];
        return new BlobsSection(section, listItems, descItems);
    });
};
